import React, { useState, useRef } from "react";
import Topbar from "../components/Topbar";
import Sidebar from "../components/Sidebar";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function AddCatagory() {
  const token = sessionStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [formdata, setFormdata] = useState({
    catagoryname: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const fileInputRef = useRef(null); // Create a ref for the file input

  const handleChange = (e) => {
    setFormdata({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      // Create a preview URL for the selected image
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Use FormData to handle file uploads
    const data = new FormData();
    data.append("catagoryname", formdata.catagoryname);
    if (imageFile) {
      data.append("image", imageFile);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/addproductcatagory`,
        {
          method: "POST",
          headers: {
            // "Content-Type" is not needed; the browser sets it for FormData
            Authorization: `Bearer ${token}`,
          },
          body: data,
        }
      );

      const responseData = await response.json();

      if (response.ok) {
        toast.success("Category added successfully!");
        // Reset form fields, file input, and preview
        setFormdata({ catagoryname: "" });
        setImageFile(null);
        setImagePreview("");
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; // Reset the file input visually
        }
      } else {
        toast.error(responseData.message || "Failed to add category");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Something went wrong! Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Category</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item active">Add Category</li>
            </ol>
          </nav>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Add New Category</h5>
            <form className="row g-3 pt-3" onSubmit={handleSubmit}>
              <div className="col-md-6">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="Enter Category Name"
                    name="catagoryname"
                    value={formdata.catagoryname}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">Category Name</label>
                </div>
              </div>

              <div className="col-md-6">
                <label htmlFor="categoryImage" className="form-label">
                  Category Image
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="categoryImage"
                  name="image"
                  onChange={handleFileChange}
                  ref={fileInputRef} // Assign the ref to the file input
                  accept="image/*" // Accept only image files
                />
              </div>

              {imagePreview && (
                <div className="col-12 mt-3">
                  <p>Image Preview:</p>
                  <img
                    src={imagePreview}
                    alt="Category Preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}

              <div className="text-start d-flex gap-3 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Adding..." : "Add Category"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default AddCatagory;
